import React from "react";

export default function Numberbar(props) {
  const { setStateValue } = props;
  const numArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
  return (
    <div className="w-screen flex justify-center">
      <div className="w-[360px] md:w-10/12 lg:w-[80rem] h-16 flex justify-center items-center">
        {numArray.map((num) => (
          <div className="w-16 h-16 flex justify-center items-center bg-slate-800" key={num}>
            <button className="w-8 md:w-10 h-8 border-2 border-white text-white" onClick={()=>{setStateValue(num)}}>{num}</button>
          </div>
        ))}
      </div>
    </div>
  );
}
